import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';
import { visuallyHidden } from '@mui/utils';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';
import ProcedureAndTriggerForm from './procedureAndTriggerForm';
import TreatmentPlanForm from './treatmentPlanForm';
import FetSheet from './fetSheet';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { Link, useLocation } from 'react-router-dom';
import GeneralDetails from '../GeneralDetails';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../../actions';
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';
import { CustomTextArea } from '../../../../common/CustomTextArea';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import { useParams } from 'react-router-dom';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import { deleteFileApi } from '../../../../api/fileApi';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import Popover from '@mui/material/Popover';
import OpuSheet from '../opu/opuSheet';
import { renderCheckboxes } from '../../../../common/inputField';
import { Modal } from 'react-bootstrap';
// Styles for the table
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  addRowButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  saveButton: {
    display: 'flex',
    width: '150px',
    justifyContent: 'center',
    marginTop: '10px',
  },
  inputField: {
    width: '80px',
    border: 'none',
    padding: '1px',
    boxSizing: 'border-box',
    fontSize: '12px',
  },
  fieldset: {},
});

// Styled components
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//     padding: 2,
//     textAlign: 'start',
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 10,
//     padding: 2,
//     textAlign: 'start',
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: "white",
//   },
//   // hide last border
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));

// Default row structure
const defaultRow = {
  date: '',
  day: '',
  e2: '',
  p4: '',
  endometrialThickness: '',
  medicine: '',
  dose: '',
  rightOvary: '',
  dopplerRight: '',
  leftOvary: '',
  dopplerLeft: '',
  comments: '',
};

// Head cells definition
const headCells = [
  { id: 'srn', numeric: false, disablePadding: true, label: 'SRN' },
  { id: 'date', numeric: false, disablePadding: true, label: 'Date' },
  { id: 'day', numeric: false, disablePadding: false, label: 'Day' },
  { id: 'e2', numeric: false, disablePadding: false, label: 'E2' },
  { id: 'p4', numeric: false, disablePadding: false, label: 'P4' },
  {
    id: 'endometrialThickness',
    numeric: false,
    disablePadding: false,
    label: 'Endometrial Thickness',
  },
  // { id: 'medicine', numeric: false, disablePadding: false, label: 'Medicine' },
  // { id: 'dose', numeric: false, disablePadding: false, label: 'Dose' },
  {
    id: 'medicines',
    numeric: false,
    disablePadding: false,
    label: 'Medicines',
  },
  {
    id: 'rightOvary',
    numeric: false,
    disablePadding: false,
    label: 'Right Ovary',
  },
  {
    id: 'dopplerRight',
    numeric: false,
    disablePadding: false,
    label: 'Doppler Right',
  },
  {
    id: 'leftOvary',
    numeric: false,
    disablePadding: false,
    label: 'Left Ovary',
  },
  {
    id: 'dopplerLeft',
    numeric: false,
    disablePadding: false,
    label: 'Doppler Left',
  },
  { id: 'comments', numeric: false, disablePadding: false, label: 'Comments' },
];

// EnhancedTableHead component
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    showCheckboxes,
    handleAddRowMedicine,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* {showCheckboxes && (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all rows',
              }}
            />
          </TableCell>
        )} */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            // sortDirection={orderBy === headCell.id ? order : false}
          >
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            > */}
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel> */}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

// EnhancedTableToolbar component
function EnhancedTableToolbar(props) {
  const {
    numSelected,
    toggleCheckboxes,
    showCheckboxes,
    handleSaveData,
    handleDeleteRows,
  } = props;
  const classes = useStyles();

  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          FMS Data
        </Typography>
      )}
      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton onClick={handleDeleteRows}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={showCheckboxes ? 'Hide checkboxes' : 'Show checkboxes'}>
        <IconButton onClick={toggleCheckboxes}>
          {showCheckboxes ? <EditOffIcon /> : <EditIcon />}
        </IconButton>
      </Tooltip> */}
      {/* <div className={classes.saveButton}>
        <Button variant="contained" color="primary" onClick={handleSaveData}>
          Save Data
        </Button>
      </div> */}
    </Toolbar>
  );
}

// Main component
export default function Fms({ patientData, isReadOnly = false }) {
  const dispatch = useDispatch();

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('date');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [rows, setRows] = React.useState([]);
  const [showCheckboxes, setShowCheckboxes] = React.useState(false);
  const [medicineModalOpen, setMedicineModalOpen] = React.useState();

  const [activeSubTab, setActiveSubTab] = useState(1);
  const [selectedDate, setSelectedDate] = useState(patientData?.fmsData?.date);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialSubTab = parseInt(queryParams.get('subTab')) || 1;
  useEffect(() => {
    setActiveSubTab(initialSubTab);
  }, []);

  const handlePopoverOpen = (event, index) => {
    setAnchorEl(event.currentTarget);
    setActiveRow(index);
  };
  console.log(medicineModalOpen, 'medicineModalOpen');
  const handleMedicineModalOpen = (value, index) => {
    const updatedMedicineModalOpen = [...medicineModalOpen];
    updatedMedicineModalOpen[index] = value;
    setMedicineModalOpen(updatedMedicineModalOpen);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setActiveRow(null);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (patientData) {

      // Handle both current cycle and historical cycle data structures
      const fmsData = patientData.fmsData || { 
        tableData: [], 
        comments: '',
        treatmentPlanForm: {
          lmp: '',
          amh: '',
          diagnosis: '',
          plan: '',
          customTreatmentPlan: 'NC',
          customTreatmentPlanOther: '',
          treatmentPlanDate: ''
        }
      };
      
  
      
      setRows(fmsData.tableData || []);
      setMedicineModalOpen(
        new Array((fmsData.tableData || []).length).fill(false),
      );
    } else {
      console.log('No patientData received in FMS component');
    }
  }, [patientData, isReadOnly]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n, index) => index);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleCheckboxClick = (event, index) => {
    event.stopPropagation();
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleDeleteRows = (index) => {
    if (isReadOnly) {
      return;
    }
    
    console.log('test');
    // const newVisibleRows = rows.filter((_, index) => selected.includes(index));
    const newRows = rows.filter((_, i) => i !== index);
    if (newRows.length <= 0) {
      return;
    }
    setRows(newRows);
    // setSelected([]);
    // setShowCheckboxes(false);
    dispatch(setPatientData('currentCycle.fmsData.tableData', newRows));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const dateHandler = (date, index) => {
    const formattedDate = date ? date.format('YYYY-MM-DD') : '';

    const updatedRows = [...rows];
    updatedRows[index].date = formattedDate;
    setRows(updatedRows);

    dispatch(
      setPatientData(
        `currentCycle.fmsData.tableData[${index}].date`,
        formattedDate,
      ),
    );
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleInputChange = (e, rowIndex, field, medRowIndex) => {
    if (isReadOnly) {
      return; 
    }
    
    if (medRowIndex >= 0) {
      const updatedRows = [...rows];
      updatedRows[rowIndex].medicineRow[medRowIndex][field] = e.target.value;
      setRows(updatedRows);
      dispatch(
        setPatientData(
          `currentCycle.fmsData.tableData.${rowIndex}.medicineRow.${medRowIndex}.${field}`,
          e.target.value,
        ),
      );
      return;
    }
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[rowIndex][field] = e.target.value;
    setRows(updatedRows);

    dispatch(
      setPatientData(
        `currentCycle.fmsData.tableData.${rowIndex}.${name}`,
        value,
      ),
    );
  };

  const handleAddRow = () => {
    if (isReadOnly) {
      return;
    }
    
    const newRow = {
      date: '',
      day: '',
      e2: '',
      p4: '',
      endometrialThickness: '',
      medicine1: '',
      dose1: '',
      medicine2: '',
      dose2: '',
      medicine3: '',
      dose3: '',
      comments: '',
      medicineRow: [
        {
          medicine: '',
          dose: '',
        },
      ],
    };

    setRows([...rows, newRow]);
    const medicineModalOpenCopy = [...medicineModalOpen];
    medicineModalOpenCopy.push(false);
    setMedicineModalOpen(medicineModalOpenCopy);
    dispatch(
      setPatientData('currentCycle.fmsData.tableData', [...rows, newRow]),
    );
  };

  const handleAddRowMedicine = () => {
    if (isReadOnly) {
      return;
    }
    
    const updatedRows = [...rows];
    const index = updatedRows.length - 1;
    updatedRows[index].medicineRow.push({
      medicine: '',
      dose: '',
    });
    setRows(updatedRows);
    dispatch(
      setPatientData(
        `currentCycle.fmsData.tableData[${index}].medicineRow`,
        updatedRows[index].medicineRow,
      ),
    );
  };

  const handleSaveData = () => {
    const filledRows = rows.filter((row) =>
      Object.values(row).some((value) => value !== ''),
    );
    // You can replace the above console.log with an API call or any other logic to save the data
  };

  const toggleCheckboxes = () => {
    setShowCheckboxes(!showCheckboxes);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // const visibleRows = React.useMemo(
  //   () => rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
  //   [page, rowsPerPage, rows],
  // );

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingText, setLoadingText] = useState('');

  const { id: patientId } = useParams();
  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
    const medicineModalOpenCopy = [...medicineModalOpen];
    medicineModalOpenCopy.splice(index, 1);
    setMedicineModalOpen(medicineModalOpenCopy);
  };

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'FMS',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              console.log(`data`, data);
              console.log(`uploadedFiles`, uploadedFiles);
              setUploadedFiles([...uploadedFiles, data]);
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      setUploadedFiles(
        uploadedFiles.filter((data) => data.fileId !== file.fileId),
      );
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };



  return (
    <div className="card">
      <ul className="nav nav-tabs" role="tablist">
        <li
          className={`nav-item mr-1 ${activeSubTab === 1 ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setActiveSubTab(1);
          }}
        >
          <a
            href="#"
            className={`nav-link ${activeSubTab === 1 ? 'active' : ''}`}
            onClick={(e) => e.preventDefault()}
          >
            FMS Data
          </a>
        </li>
        <li
          className={`nav-item mr-1 ${activeSubTab === 2 ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setActiveSubTab(2);
          }}
        >
          <a
            href="#"
            className={`nav-link ${activeSubTab === 2 ? 'active' : ''}`}
            onClick={(e) => e.preventDefault()}
          >
            FET Sheet
          </a>
        </li>
        <li
          className={`nav-item mr-1 ${activeSubTab === 3 ? 'active' : ''} ${patientData?.fmsData?.procedureDate ? '' : 'disabled'}`}
          onClick={(e) => {
            e.preventDefault();
            if (patientData?.fmsData?.procedureDate) {
              setActiveSubTab(3);
            }
          }}
        >
          <a
            href="#"
            className={`nav-link ${activeSubTab === 3 ? 'active' : ''}`}
            onClick={(e) => e.preventDefault()}
          >
            OPU Sheet
          </a>
        </li>
      </ul>
      {/* {activeSubTab === 0 && <TreatmentPlanForm />} */}
      {activeSubTab === 1 && (
        <Box sx={{ width: '100%' }}>
          <div
            className="cycle-header"
            style={{
              margin: '10px 10px 0px 0px',
              display: 'flex',
              flexDirection: 'row-reverse',
            }}
          >
            {patientData?.createdAt ? (
              <h6>
                Created On:{' '}
                {patientData.createdAt
                  ? dayjs(patientData.createdAt).format('DD-MM-YYYY')
                  : ''}
              </h6>
            ) : null}
          </div>
          <GeneralDetails isReadOnly={isReadOnly} />
          <TreatmentPlanForm isReadOnly={isReadOnly} />
          <Paper sx={{ width: '100%', mb: 2 }}>
            <EnhancedTableToolbar
              numSelected={selected.length}
              toggleCheckboxes={toggleCheckboxes}
              showCheckboxes={showCheckboxes}
              handleSaveData={handleSaveData}
              handleDeleteRows={handleDeleteRows}
            />
            <div style={{ display: 'flex', gap: '8px' }}>
              {!isReadOnly && (
                <IconButton
                  onClick={() => handleAddRow()}
                  size="small"
                  style={{ marginLeft: 8 }}
                >
                  <AddIcon />
                </IconButton>
              )}
              {/* <FormControlLabel
                  control={
                    <Switch checked={dense} onChange={handleChangeDense} />
                  }
                  label="Dense padding"
                /> */}
            </div>
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size={dense ? 'small' : 'medium'}
                aria-label="a dense table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  showCheckboxes={showCheckboxes}
                  handleAddRowMedicine={handleAddRowMedicine}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = selected.includes(index);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                        sx={{ cursor: 'pointer', height: '40px' }}
                      >
                        {/* {showCheckboxes && (
                            <TableCell
                              padding="checkbox"
                              onClick={(event) => handleCheckboxClick(event, index)}
                            >
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            </TableCell>
                          )} */}
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          sx={{
                            minWidth: '40px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'center',
                          }}
                          s
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '150px', whiteSpace: 'nowrap' }}
                        >
                          <DateComponent
                            selectedDate={
                              row.date ? dayjs(row.date, 'YYYY-MM-DD') : null
                            }
                            handleDateChange={(date) => {
                              if (!isReadOnly) {
                                dateHandler(date, index)
                              }
                            }}
                            disabled={isReadOnly}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.day || ''}
                            onChange={(e) => handleInputChange(e, index, 'day')}
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.e2 || ''}
                            onChange={(e) => handleInputChange(e, index, 'e2')}
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.p4 || ''}
                            onChange={(e) => handleInputChange(e, index, 'p4')}
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.endometrialThickness || ''}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                index,
                                'endometrialThickness',
                              )
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          {!isReadOnly ? (
                            <Button
                              onClick={() => handleMedicineModalOpen(true, index)}
                            >
                              Add Medicines
                            </Button>
                          ) : (
                            <Button
                              onClick={() => handleMedicineModalOpen(true, index)}
                              disabled={false}
                            >
                              View Medicines
                            </Button>
                          )}
                          {medicineModalOpen[index] && (
                            <Modal
                              show={medicineModalOpen[index]}
                              onHide={() => {
                                handleMedicineModalOpen(false, index);
                              }}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Medicine Doses </Modal.Title>
                              </Modal.Header>

                              <Modal.Body>
                                {!isReadOnly && (
                                  <IconButton
                                    onClick={() => handleAddRowMedicine()}
                                    size="small"
                                    style={{ marginLeft: 8 }}
                                  >
                                    Add Row
                                  </IconButton>
                                )}
                                <TableContainer>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Medicine</TableCell>
                                      <TableCell>Dose</TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {(row.medicineRow || []).map((med, medIndex) => (
                                      <TableRow key={medIndex}>
                                        <TableCell>
                                          <TextField
                                            value={med.medicine || ''}
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                index,
                                                'medicine',
                                                medIndex,
                                              )
                                            }
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled={isReadOnly}
                                            InputProps={{
                                              readOnly: isReadOnly,
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            value={med.dose || ''}
                                            onChange={(e) =>
                                              handleInputChange(
                                                e,
                                                index,
                                                'dose',
                                                medIndex,
                                              )
                                            }
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled={isReadOnly}
                                            InputProps={{
                                              readOnly: isReadOnly,
                                            }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </TableContainer>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="primary"
                                  onClick={() => {
                                    handleMedicineModalOpen(false, index);
                                  }}
                                >
                                  Save
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          )}
                        </TableCell>
                        {/* <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.medicine}
                            onChange={(e) =>
                              handleInputChange(e, index, 'medicine')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.dose}
                            onChange={(e) =>
                              handleInputChange(e, index, 'dose')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        </TableCell> */}
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.rightOvary || ''}
                            onChange={(e) =>
                              handleInputChange(e, index, 'rightOvary')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.dopplerRight || ''}
                            onChange={(e) =>
                              handleInputChange(e, index, 'dopplerRight')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.leftOvary || ''}
                            onChange={(e) =>
                              handleInputChange(e, index, 'leftOvary')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ minWidth: '100px', padding: '4px' }}
                        >
                          <TextField
                            value={row.dopplerLeft || ''}
                            onChange={(e) =>
                              handleInputChange(e, index, 'dopplerLeft')
                            }
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={isReadOnly}
                            InputProps={{
                              readOnly: isReadOnly,
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            minWidth: '100px',
                            padding: '4px',
                            textAlign: 'center',
                          }}
                        >
                          <i
                            className="fa fa-comment"
                            onClick={(event) => handlePopoverOpen(event, index)}
                            style={{ fontSize: '20px' }}
                          ></i>
                          <Popover
                            open={open && activeRow === index}
                            anchorEl={anchorEl}
                            onClose={handlePopoverClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                          >
                            <div
                              style={{
                                padding: '10px',
                                position: 'relative',
                                paddingTop: '18px',
                              }}
                            >
                              <i
                                onClick={handlePopoverClose}
                                className="fa fa-close"
                                style={{
                                  position: 'absolute',
                                  top: 1,
                                  left: 2,
                                  zIndex: 10,
                                  cursor: 'pointer',
                                }}
                              ></i>
                              <CustomTextArea
                                value={row.comments || ''}
                                onChange={(e) =>
                                  handleInputChange(e, index, 'comments')
                                }
                                name="comments"
                                className="col-lg-12 col-md-4 padding-0"
                                maxRows={10}
                                disabled={isReadOnly}
                                readOnly={isReadOnly}
                              />
                            </div>
                          </Popover>
                        </TableCell>
                        <TableCell>
                          {!isReadOnly && (
                            <IconButton
                              onClick={() => handleDeleteRows(index)}
                              size="small"
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
              }}
            >
              {/* <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  style={{ height: 'fit-content' }}
                  onClick={() => handleAddRow()}
                >
                  Add Row
                </Button> */}

              {/* <FormControlLabel
                  control={
                    <Switch checked={dense} onChange={handleChangeDense} />
                  }
                  label="Dense padding"
                /> */}
              {/* </div> */}
              {/* <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </Box>
          </Paper>
          <ProcedureAndTriggerForm
            type={'fms'}
            data={{
              procedureDate: '',
              procedureTime: '',
              triggerDate: '',
              triggerTime: '',
            }}
          />
          <label>Comments </label>
          <CustomTextArea
            value={patientData.fmsData?.comments || ''}
            onChange={(e) => {
              if (!isReadOnly) {
                dispatch(
                  setPatientData(`currentCycle.fmsData.comments`, e.target.value),
                );
              }
            }}
            name="comments"
            className="col-lg-12 col-md-4 padding-0"
            maxRows={10}
            disabled={isReadOnly}
            readOnly={isReadOnly}
          />
          {/* <div style={{ paddingTop: '50px' }}>
            <div className="row clearfix">
              <FileUploadCard
                setFiles={setFiles}
                setUploadedFiles={setUploadedFiles}
                files={uploadedFiles}
                handleUpload={handleUpload}
                id={patientId}
              />
              {uploadedFiles.map((data, i) => {
                console.log('uploadedFiles', uploadedFiles);
                return (
                  <FileDocumentCard
                    key={i}
                    DocumentName={data.displayFileName}
                    DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                    DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                    ImageUrl={
                      data?.fileType?.includes('image')
                        ? data.presignedUrl
                        : undefined
                    }
                    handleDeleteFile={() => handleDeleteFile(data)}
                    file={data}
                    fileUniquePrefix={`patient-${patientId}`}
                  />
                );
              })}
            </div>
          </div> */}
        </Box>
      )}
      {activeSubTab === 2 && <FetSheet isReadOnly={isReadOnly} patientData={patientData} />}
      {activeSubTab === 3 && <OpuSheet isReadOnly={isReadOnly} patientData={patientData} />}
    </div>
  );
}
